import { useState, useEffect, useMemo } from 'react';
import debounce from 'lodash/debounce';

export function useDebounce<T>(
    value: T,
    delayMs: number,
    initialValue: T = value,
): T {
    const [debouncedValue, setDebouncedValue] = useState(initialValue);

    const debouncedSetter = useMemo(
        () => debounce((next: T) => setDebouncedValue(next), delayMs),
        [delayMs],
    );

    useEffect(() => {
        debouncedSetter(value);
        return () => debouncedSetter.cancel();
    }, [value, debouncedSetter]);

    return debouncedValue;
}
